import { HvlBaseModel } from '@hvlng/framework-bff/core';

export function removeEmptyFields(obj, update = false) {
    if (typeof obj !== 'object') {
        return obj;
    }
    let oKeys = Object.keys(obj);
    for (let j = 0; j < oKeys.length; j++) {
        let p = oKeys[j];
        switch (typeof obj[p]) {
            case 'object':
                if (Array.isArray(obj[p])) {
                    for (let i = 0; i < obj[p].length; i++) {
                        obj[p][i] = removeEmptyFields(obj[p][i], update);
                        if (isEmpty(obj[p][i])) {
                            obj[p].splice(i, 1);
                            i--;
                        }
                    }
                    if (obj[p].length === 0) {
                        if (Array.isArray(obj)) {
                            obj.splice(parseInt(p), 1);
                            j--;
                        } else {
                            delete obj[p];
                        }
                    }
                } else {
                    if (update == false && (p === 'id' || p === 'uuid' || p === 'version')) {
                        obj[p] = null;
                    }
                    if (!(obj[p] instanceof Date)) {
                        if (isEmpty(obj[p])) {
                            delete obj[p];
                        } else {
                            obj[p] = removeEmptyFields(obj[p], update);
                            if (isEmpty(obj[p])) {
                                delete obj[p];
                            }
                        }
                    }
                }
                break;
            default:
                if ((isEmpty(obj[p]), update)) {
                    delete obj[p];
                }
                break;
        }
    }
    if (Object.keys(obj).length === 0) {
        return;
    }
    return obj;
}

export function isEmpty(obj) {
    return (
        obj === '' || obj === null || JSON.stringify(obj) === '{}' || JSON.stringify(obj) === '[]' || obj === undefined
    );
}

export function deepSearch(target, update = false) {
    if (typeof target === 'object') {
        for (let key in target) {
            if (typeof target[key] === 'object') {
                deepSearch(target[key], update);
            } else {
                if (update == false && (key === 'id' || key === 'uuid' || key === 'version')) {
                    target[key] = null;
                }
            }
        }
    }
    return target;
}

export function clearHvlBaseFields(model: HvlBaseModel) {
    model.id = null;
    model.uuid = null;
    model.dateCreated = null;
    model.createdBy = null;
    model.dateUpdated = null;
    model.updatedBy = null;
    model.version = null;
}
